var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"App-buttons"},[_c('button-component',{attrs:{"color":_vm.color,"value":_vm.text,"is-disabled":_vm.isDisabled,"field-id":"questionButton","log-action":"abstain-modal"},on:{"click-abstain-modal":_vm.trackClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }